import type { Consultation } from "sdk/consultations";
import type { DiagnosticProduct } from "sdk/diagnosticUserProducts";

export interface LabTest {
  id: number;
  name: string;
  provider_type: string;
  slug: string;
  status: "created" | "assigned" | "ordered" | "completed";
  result_download_url?: string;
  result_media_id?: string;
  completed_at?: string;
  external_id: string;
  fh_id?: string;
  consultation?: Consultation;
  diagnostic_user_product_id: number;
  diagnostic_product: DiagnosticProduct;
  created_at: string;
}

export interface Facility {
  name: string;
  distance: number;
  faxNumber: string;
  telephone: string;
  address: {
    lines: string[];
    city: string;
    postalCode: string;
    state: string;
    country: string;
  };
  capabilities?: string[];
}

export type FacilitiesSearchResponse = Facility[];

export interface FacilitiesSearchParams {
  product_slug: string;
  postal_code: string;
  radius?: string;
}

export const facilitiesSearchQuery = (params: FacilitiesSearchParams) => {
  const searchParams: Record<string, string> = {
    product_slug: params.product_slug,
    postal_code: params.postal_code,
  };
  if (params.radius) {
    searchParams.radius = params.radius;
  }

  return {
    url: `/api/v1/diagnostics/lab_tests/facilities?${new URLSearchParams(searchParams).toString()}`,
    method: "GET" as const,
  };
};
